import script from "./AllOrdersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AllOrdersTable.vue?vue&type=script&setup=true&lang=js"

import "./AllOrdersTable.vue?vue&type=style&index=0&id=260a6bc7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260a6bc7"]])

export default __exports__